import { put, call, take, fork } from 'redux-saga/effects'
import { getCertificatePaymentSettingService } from 'src/api/certificate'
import {
  getCertificatePaymentSettingSuccess,
  getCertificatePaymentSettingError,
} from 'src/reducers/certificate/action'
import { GET_CERTIFICATE_PAYMENT_SETTING } from 'src/reducers/certificate/type'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'
import generalSaga from '../general'

function* flow(payload) {
  const { collectionId, callback } = payload
  try {
    const response = yield call(getCertificatePaymentSettingService, collectionId)
    // Backend wraps every response in {operationCode, statusCode, data}; the
    // actual DTO lives at response.data. Unwrap before storing so consumers
    // see the bare DTO shape they expect.
    const dto = response?.data ?? response
    yield put(getCertificatePaymentSettingSuccess(dto))
    if (callback) callback(dto)
    yield put(operationSuccess())
  } catch (error) {
    yield put(getCertificatePaymentSettingError(error))
    if (callback) callback(null, error)
    yield put(operationFail(error))
  }
}

export default function* getCertificatePaymentSettingWatcher() {
  while (true) {
    const action = yield take(GET_CERTIFICATE_PAYMENT_SETTING)
    yield fork(generalSaga, flow, action.payload)
  }
}
